enum PreQualificationLetterPurpose {
  FREEHOLD = 'FREEHOLD',
  CONDOMINIUM = 'CONDOMINIUM',
  UNKNOWN = 'UNKNOWN',
}

export default PreQualificationLetterPurpose;
